import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const headerSelector = '.js-header';
	const headerElem = document.querySelector(headerSelector);

	if (!headerElem) {
		return;
	}

	const { Header } = await import('./header');

	const header = new Header({
		selector: headerSelector,
		elem: headerElem,
	});
	header.init();
});
